<template>
  <Dialog :commonDialog="bDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex> Manage Service type </v-flex>
        <v-flex class="text-right">
          <v-btn depressed small class="mx-4 white--text" color="cyan" v-on:click="createServiceType">
            <span class="font-size-16 font-weight-600">Add Service</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative">
        <v-form ref="ticketCollecttionForm" lazy-validation v-on:submit.stop.prevent="updateProductBrand">
          <v-container class="py-0">
            <v-row class="py-0">
              <v-col md="12" class="py-0">
                <table class="width-100">
                  <tbody v-for="(type, index) in service" :key="index">
                    <!-- Row 1: Service Type and Delete Icon -->
                    <tr>
                      <td colspan="2">
                        <v-text-field v-model.trim="type.type" dense filled placeholder="Service Type" solo flat
                          class="px-2 py-1" hide-details :disabled="pageLoading" :loading="pageLoading" :rules="[
                            validateRules.required(type.type, 'Service Type'),
                          ]" color="cyan" />
                      </td>
                      <td width="50" v-if="service.length > 1" class="text-center">
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon :disabled="type?.id && type?.service_value_count !== '0'
                              " @click="deleteHourType(index)" color="deep-orange" v-bind="attrs" v-on="on">
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Click here to delete</span>
                        </v-tooltip>
                      </td>
                    </tr>

                    <!-- Row 2: Checkboxes aligned with text field -->
                    <tr>
                      <td colspan="3" class="px-4 py-1 ml-3">
                        <div class="d-flex align-center">
                          <!-- Hours Visible -->
                          <div class="d-flex align-center mr-5">
                            <span class="mr-2">Hours Visible</span>
                            <v-tooltip top content-class="custom-top-tooltip">
                              <template v-slot:activator="{ on, attrs }">
                                <v-checkbox v-model="type.is_hours_visible"   hide-details
                                  :disabled="type?.id && type?.service_value_count !== '0'" color="cyan"
                                  class="dense-checkbox mt-n2" v-bind="attrs" v-on="on" />
                              </template>
                              <span>Toggle hours visibility</span>
                            </v-tooltip>
                          </div>

                          <!-- House Type Visible -->
                          <div class="d-flex align-center">
                            <span class="mr-2">House Type Visible</span>
                            <v-tooltip top content-class="custom-top-tooltip">
                              <template v-slot:activator="{ on, attrs }">
                                <v-checkbox v-model="type.is_house_type_visible"
                                  :disabled="type?.id && type?.service_value_count !== '0'" hide-details color="cyan"
                                  class="dense-checkbox mt-n2" v-bind="attrs" v-on="on" />
                              </template>
                              <span>Toggle house type visibility</span>
                            </v-tooltip>
                          </div>
                        </div>
                        <span v-if="type?.id && type?.service_value_count !== '0'"
                          class="red--text font-weight-400">This Service type
                          already used in other
                          transactions</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn depressed :disabled="pageLoading" :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text" color="cyan" v-on:click="updateServiceType">
        Save
      </v-btn>
      <v-btn depressed :disabled="pageLoading" class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)">
        Close
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
// import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CommonMixin from "@/core/plugins/common-mixin";
import { cloneDeep } from "lodash";

export default {
  mixins: [ValidationMixin, CommonMixin],
  props: {
    bDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    service: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
    /* existCategory: {
      type: String,
      default: null,
    }, */
  },
  watch: {
    service: {
      deep: true,
      immediate: true,
      handler(param) {
        this.serviceList = cloneDeep(param);
      },
    },
  },
  data: () => {
    return {
      pageLoading: false,
      serviceList: [
        {
          text: null,
        },
      ],
    };
  },
  methods: {
    // showAddFields(index) {
    //   this.$set(this.viewAddButton, index, !this.viewAddButton[index]);
    // },
    updateServiceType() {
      const _this = this;
      // const formErrors = _this.validateForm(_this.$refs.ticketCollecttionForm);

      // if (formErrors.length) {
      //   for (let i = 0; i < formErrors.length; i++) {
      //     ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
      //     _this.pageLoading = false;
      //   }
      //   // return false;
      // }
      _this.pageLoading = true;
      _this.$store;
      _this.$store;
      _this.$store
        .dispatch(PATCH, {
          url: "update-serviceType",
          data: { service_value: _this.serviceList },
        })
        .then(() => {
          _this.$emit("close-dialog", true);
          _this.$emit("get-service-type", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    createServiceType() {
      this.service.push({
        text: null,
      });
    },
    deleteHourType(index) {
      if (this.service.length > 1) {
        this.service.splice(index, 1);
      }
    },

    // isHourVisible(event, id) {
    //   const _this = this;
    //   _this.$store
    //     .dispatch(PATCH, {
    //       url: "update-hour-visiblity",
    //       data: { service_type_id: id, is_hours_visible: event },
    //     })
    //     .then(() => {
    //       // _this.$emit("close-dialog", true);
    //       _this.$emit("get-service-type", true);
    //       // ProductBrandEventBus.$emit("refress-brand", true);
    //     })
    //     .catch((error) => {
    //       _this.logError(error);
    //     })
    //     .finally(() => {
    //       _this.pageLoading = false;
    //     });
    // },
    // isHouseVisible(event, id) {
    //   const _this = this;
    //   _this.$store
    //     .dispatch(PATCH, {
    //       url: "update-house-visiblity",
    //       data: { service_type_id: id, is_house_type_visible: event },
    //     })
    //     .then(() => {
    //       // _this.$emit("close-dialog", true);
    //       _this.$emit("get-service-type", true);
    //       // ProductBrandEventBus.$emit("refress-brand", true);
    //     })
    //     .catch((error) => {
    //       _this.logError(error);
    //     })
    //     .finally(() => {
    //       _this.pageLoading = false;
    //     });
    // },
  },
  components: {
    Dialog,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
